const styles = theme => ({
    listItemRoot: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: theme.spacing(4),
        borderBottom: `solid 1px gainsboro`
    },
    chevron: {
        color: theme.palette.primary.main
    }
});

export default styles;